import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BatchContext } from "../../../contexts/BatchContext";
import { OTP } from "../OTP/OTP";
import { AdditionalSignaturesContext } from "../../../contexts/AdditionalSignaturesContext";
import { AdditionalSignaturesFinalFlow } from "../AdditionalSignaturesFinalFlow/AdditionalSignaturesFinalFlow";

export const OTPDraw = ({ documents, emailId, setLoadingMorePages, otpCode, attachedImages, setOTPDraw }) => {
    const navigate = useNavigate();
    const { batchOTP, batchAttachedImages } = useContext(BatchContext);
    const [otpFlow, setOTPFlow] = useState(false);
    const [completeAdditionalSignaturesFlow, setCompleteAdditionalSignaturesFlow] = useState(false);
    const { isSignatureBoxesFlow } = useContext(AdditionalSignaturesContext);

    const documentData = Array.isArray(documents) ? documents[0] : documents;
    const phoneNumber = documentData.SignerDTO.PhoneNumber

    const email = documentData.SignerDTO.eMail;

    const selectedMethod = documentData.SignerDTO.OTPPrimaryChannel?.toLowerCase();;

    useEffect(() => {
        let link = "/sign";
        if (batchOTP || otpCode) {
            const { SkipSigDraw } = documentData.SignerDTO;

            // OTP Flow
            if (SkipSigDraw) return setOTPFlow(true);

            const shouldAttachDocumentImages = documentData.SignerDTO.AttachIdDocImages && typeof attachedImages === 'undefined' && !batchAttachedImages;
            if (shouldAttachDocumentImages) {
                link = "/attach-images";
            } else {
                if (isSignatureBoxesFlow) return setCompleteAdditionalSignaturesFlow(true);
            }

            navigate(link, {
                state: {
                    documents: documentData,
                    emailId,
                    otpCode,
                    attachedImages: shouldAttachDocumentImages
                }
            });
            return;
        }

        if (selectedMethod === "sms" || selectedMethod === "whatsapp") {
            link = '/sms';
        } else if (selectedMethod === "smswhatsapp") {
            link = '/select-method-otp';
        }

        link = phoneNumber ? link : '/customsms';

        navigate(link, {
            state: { documents, emailId, phoneNumber, selectedMethod }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <>
        {otpFlow && <OTP signerGuid={documents.SignerDTO.SignerGUI} otpCode={batchOTP || otpCode} emailId={emailId} docGuid={documents.DocGUI} email={email} setOTPDraw={setOTPDraw} setLoadingMorePages={setLoadingMorePages} />}
        {completeAdditionalSignaturesFlow && <AdditionalSignaturesFinalFlow otpCode={batchOTP || otpCode} emailId={emailId} />}
    </>;
}